const borderRadius = {
  xs: '2px',
  sm: '4px',
  md: '6px',
  lg: '8px',
  xl: '10px',
  '2xl': '12px',
  '3xl': '16px',
  '4xl': '20px',
  '5xl': '24px',
  '6xl': '28px',
  '7xl': '32px',
  '8xl': '36px',
  '9xl': '40px',
};

export default borderRadius;
